module.exports = __webpack_public_path__ + "img/step-6-s.82f76e62.png";